import { Paper } from "@mui/material";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getSustanciasPlanillaA, postGrupoSustanciasA, } from "../../../../redux/actions/rgrl";
import { decretoToEnum, preguntaHabilitantePlanillaAPorDecreto } from "../../../commons/enums/RgrlEnums";
import RequeridoLabel from "../../../commons/labels/RequeridoLabel";
import CircularLoading from "../../../commons/loading/CircularLoading";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import PlanillaTable from "../../../commons/planillas/PlanillaTable";
import { StyledRgrl } from "../../../styled/Prevencion";

const PlanillaAContainer = ({ nextForm }) => {
  const dispatch = useDispatch();
  const postRgrl = useSelector(
    (state) => state.rgrl.postRgrl,
  );
  const sustancias = useSelector((state) => state.rgrl.sustanciasA);
  const sustanciasPost = useSelector((state) => state.rgrl.postRgrl.planillaA);
  const saveOnUnmountRef = useRef(true);
  const [contador, setContador] = useState(0);
  const [grupoActual, setGrupoActual] = useState(null);

  //numero x grupo establecido
  const preguntasPorGrupo = 10;

  const loading = !grupoActual || sustancias.loading;

  // hace falta redondear porque si la cantidad total de preguntas es impar
  // la division da como resultado un numero decimal
  const totalGrupos = Math.ceil(
    sustancias.data[0]?.itemsFormularioArt.length / preguntasPorGrupo
  );
  const tituloGrupo = sustancias.data[0]?.nombre.toLowerCase();

  useEffect(() => {
    dispatch(getSustanciasPlanillaA());
  }, []);

  useEffect(() => {
    if (sustancias.data?.length && !sustanciasPost.length) {
      setGrupoActual(
        sustancias.data[0].itemsFormularioArt.slice(
          contador * preguntasPorGrupo,
          contador * preguntasPorGrupo + preguntasPorGrupo
        )
      );
    }
  }, [sustancias.data]);

  useEffect(() => {
    if (sustanciasPost.length) {
      if (sustanciasPost.length <= contador * preguntasPorGrupo) {
        setGrupoActual(
          sustancias.data[0].itemsFormularioArt.slice(
            contador * preguntasPorGrupo,
            contador * preguntasPorGrupo + preguntasPorGrupo
          )
        );
      } else {
        setGrupoActual(
          sustanciasPost.slice(
            contador * preguntasPorGrupo,
            contador * preguntasPorGrupo + preguntasPorGrupo
          )
        );
      }
    }
  }, [contador]);

  const preguntaHabilitante = useMemo(() => {
    return preguntaHabilitantePlanillaAPorDecreto[decretoToEnum(postRgrl.decretoForm.nombre)];
  }, [postRgrl.decretoForm.nombre]);

  const disabled = useMemo(() => {
    const preguntas = postRgrl.preguntasDecreto.preguntas.flat()
      .map((a) => a.itemsFormularioArt)
      .flat();
    if (preguntas.some((p) => p.secuencia === preguntaHabilitante && p.resultado === 1)) {
      return false;
    }
    return true;
  }, [preguntaHabilitante, postRgrl.preguntasDecreto.preguntas])

  const handleSave = useCallback((values) => {
    dispatch(postGrupoSustanciasA(values.opciones));
  }, [dispatch]);

  const handleSubmit = (values) => {
    handleSave(values);
    if (
      contador >=
      Math.ceil(
        sustancias.data[0].itemsFormularioArt.length / preguntasPorGrupo
      ) -
      1
    ) {
      // Los values actuales no estan aun actualizados en postRgrl
      if (postRgrl.planillaA.slice(0, -values.opciones.length).some((p) => p.resultado === "1") || values.opciones.some((p) => p.resultado === "1") || disabled) {
        saveOnUnmountRef.current = false;
        nextForm("PlanillaC");
      } else {
        toast.error(`Al tener la pregunta del decreto ${preguntaHabilitante} marcado en SI, debe marcar algún ítem de esta planilla. Por favor revisar los ítems/preguntas para continuar`);
      }

    } else {
      setContador((contador) => contador + 1);
    }
  };

  const handleGoBack = (values) => {
    setContador((contador) => contador - 1);
    dispatch(postGrupoSustanciasA(values.opciones));
  };

  return (
    <>
      <FechaPresentacionLabel />
      {!!disabled && (
        <RequeridoLabel text={`Para marcar las sustancias de la planilla A, debe marcar la pregunta ${preguntaHabilitante} como SI`} />
      )}
      <Paper>
        {!loading ? (
          <PlanillaTable
            data={grupoActual}
            tituloGrupo={tituloGrupo}
            totalGrupos={totalGrupos}
            contador={contador}
            handleSubmit={handleSubmit}
            handleGoBack={handleGoBack}
            columns={[
              { id: `pregunta`, label: "Sustancia" },
              { id: "si", label: "Sí" },
              { id: "no", label: "No" },
            ]}
            disabled={disabled}
            saveOnUnmount={saveOnUnmountRef}
            handleSaveOnUnmount={handleSave}
          />
        ) : (
          <StyledRgrl.LoadingContainer>
            <CircularLoading />
          </StyledRgrl.LoadingContainer>
        )}
      </Paper>
    </>
  );
};

export default PlanillaAContainer;
